import { render, staticRenderFns } from "./AttachmentsModal.vue?vue&type=template&id=c7bfe1c4&scoped=true&"
import script from "./AttachmentsModal.vue?vue&type=script&lang=ts&"
export * from "./AttachmentsModal.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentsModal.vue?vue&type=style&index=0&id=c7bfe1c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bfe1c4",
  null
  
)

export default component.exports